import React from 'react';
import Flux  from '../../../flux/Flux';

class VXBalance extends React.PureComponent {

	constructor(props) {
		super(props);
		this.state         = {
			guestBalanceFormatted: Flux.Guest.getBalanceFormatted(),
		};
		this.onStoreChange = this.onStoreChange.bind(this);
	}

	componentDidMount() {
		Flux.Guest.addChangeListener(this.onStoreChange);
	}

	componentWillUnmount() {
		Flux.Guest.removeChangeListener(this.onStoreChange);
	}

	onStoreChange() {
		this.setState({
			guestBalanceFormatted: Flux.Guest.getBalanceFormatted(),
		});
	}

	render() {
		return (
			<span>{this.state.guestBalanceFormatted}</span>
		);
	}
}

export default VXBalance;
